import React from "react";
import {
  Grid,
  Button,
  Skeleton,
  Box,
  Modal,
  Typography,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  TextField,
  Pagination,
  IconButton,
} from "@mui/material";
import { Close, FilterList } from "@mui/icons-material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CheckboxState } from "../../pages/veiculos";

interface FilterVehicleProps {
  loading: boolean;
  isFetching: boolean;
  vehicles: any[];
  currentPage: number;
  handleChangePage: (event: React.ChangeEvent<unknown>, value: number) => void;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  openModal: boolean;
  isAdmin: boolean;
  companies: any[];
  selectedCompanyId: number | null;
  setSelectedCompanyId: (id: number | null) => void;
  checkboxState: CheckboxState;
  handleCheckboxChange: (filterName: keyof CheckboxState) => void;
  selectedFilter: string | null;
  startDateArmazenagem: any;
  endDateArmazenagem: any;
  setStartDateArmazenagem: (date: any) => void;
  setEndDateArmazenagem: (date: any) => void;
  startDateChecklist: any;
  endDateChecklist: any;
  setStartDateChecklist: (date: any) => void;
  setEndDateChecklist: (date: any) => void;
  applyFilters: () => void;
  handleResetFilters: () => void;
  totalPage: number;
}

const FilterVehicle: React.FC<FilterVehicleProps> = ({
  loading,
  isFetching,
  vehicles,
  currentPage,
  handleChangePage,
  handleOpenModal,
  handleCloseModal,
  openModal,
  isAdmin,
  companies,
  selectedCompanyId,
  setSelectedCompanyId,
  checkboxState,
  handleCheckboxChange,
  selectedFilter,
  startDateArmazenagem,
  endDateArmazenagem,
  setStartDateArmazenagem,
  setEndDateArmazenagem,
  startDateChecklist,
  endDateChecklist,
  setStartDateChecklist,
  setEndDateChecklist,
  applyFilters,
  handleResetFilters,
  totalPage,
}) => {
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    handleChangePage(event, newPage);
  };

  const handleCheckboxChangeWithLogic = (filterName: keyof CheckboxState) => {
    const newState = { ...checkboxState };

    switch (filterName) {
      case "veiculosEntregues":
        newState.veiculosEntregues = !checkboxState.veiculosEntregues;
        if (newState.veiculosEntregues) {
          newState.dataSemChecklist = false;
          newState.dataChecklistAtrasado = false;
        }
        break;

      case "dataSemChecklist":
        newState.dataSemChecklist = !checkboxState.dataSemChecklist;
        if (newState.dataSemChecklist) {
          newState.veiculosEntregues = false;
          newState.dataChecklistAtrasado = false;
          newState.dataChecklist = false;
        }
        break;

      case "dataChecklistAtrasado":
        newState.dataChecklistAtrasado = !checkboxState.dataChecklistAtrasado;
        if (newState.dataChecklistAtrasado) {
          newState.veiculosEntregues = false;
          newState.dataSemChecklist = false;
        }
        break;

      case "dataChecklist":
        newState.dataChecklist = !checkboxState.dataChecklist;
        if (newState.dataChecklist) {
          newState.dataSemChecklist = false;
        }
        break;

      default:
        newState[filterName] = !checkboxState[filterName];
        break;
    }

    handleCheckboxChange(filterName);
  };

  return (
    <React.Fragment>
      <Grid item xs={6} textAlign="right">
        {loading ? (
          <Skeleton
            variant="rectangular"
            width={140}
            height={30}
            sx={{
              borderRadius: 2,
              bgcolor: "grey.400",
              marginLeft: "auto",
            }}
          />
        ) : (
          <Button
            variant="text"
            startIcon={<FilterList />}
            onClick={handleOpenModal}
            sx={{
              fontSize: { xs: 12, sm: 16 },
            }}
          >
            Filtros adicionais
          </Button>
        )}
      </Grid>
      <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
        <Pagination
          count={totalPage}
          page={currentPage}
          onChange={handlePageChange}
        />
      </Box>

      <Modal open={openModal} disableEscapeKeyDown disableEnforceFocus>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            width: { xs: 270, sm: 450, md: 650, lg: 700 },
            maxHeight: "90%",
            overflowY: "auto",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
          <Typography variant="h6" component="h2" mb={2}>
            Filtros Por:
          </Typography>
          <Grid container spacing={0}>
            {isAdmin && (
              <Grid item xs={12} mb={2}>
                <Autocomplete
                  options={companies}
                  getOptionLabel={(option) => option.nome_empresa}
                  value={companies.find(
                    (company) => company.id === selectedCompanyId
                  )}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setSelectedCompanyId(newValue.id);
                    } else {
                      setSelectedCompanyId(null);
                    }
                  }}
                  componentsProps={{
                    popper: {
                      style: { zIndex: 1301 },
                    },
                  }}
                  noOptionsText="Nenhuma empresa encontrada!"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Empresa"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
            )}
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkboxState.veiculosEntregues}
                    onChange={() => handleCheckboxChange("veiculosEntregues")}
                    disabled={
                      checkboxState.dataSemChecklist ||
                      checkboxState.dataChecklistAtrasado
                    }
                  />
                }
                label="Veículos Entregues"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkboxState.dataArmazenagem}
                    onChange={() => handleCheckboxChange("dataArmazenagem")}
                  />
                }
                label="Data de Armazenagem"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkboxState.dataChecklist}
                    onChange={() => handleCheckboxChange("dataChecklist")}
                    disabled={checkboxState.dataSemChecklist}
                  />
                }
                label="Data de Checklist"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkboxState.dataSemChecklist}
                    onChange={() => handleCheckboxChange("dataSemChecklist")}
                    disabled={
                      checkboxState.veiculosEntregues ||
                      checkboxState.dataChecklist ||
                      checkboxState.dataChecklistAtrasado
                    }
                  />
                }
                label="Sem Checklist"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkboxState.dataChecklistAtrasado}
                    onChange={() =>
                      handleCheckboxChangeWithLogic("dataChecklistAtrasado")
                    }
                    disabled={
                      checkboxState.dataSemChecklist ||
                      checkboxState.veiculosEntregues
                    }
                  />
                }
                label="Checklist Atrasado"
              />
            </Grid>
          </Grid>
          {checkboxState.dataArmazenagem && (
            <>
              <Typography variant="h6" component="h2" mt={1}>
                Data de Armazenagem
              </Typography>
              <Grid container spacing={2} mt={0}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="De"
                      format="DD/MM/YYYY"
                      value={startDateArmazenagem}
                      onChange={(newValue: any) =>
                        setStartDateArmazenagem(newValue)
                      }
                      sx={{
                        width: "100%",
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#303030",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 3,
                          backgroundColor: "white",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="Até"
                      format="DD/MM/YYYY"
                      value={endDateArmazenagem}
                      onChange={(newValue: any) =>
                        setEndDateArmazenagem(newValue)
                      }
                      sx={{
                        width: "100%",
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#303030",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 3,
                          backgroundColor: "white",
                        },
                      }}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>
            </>
          )}
          {checkboxState.dataChecklist && (
            <>
              <Typography variant="h6" component="h2" mt={3}>
                Data de Checklist
              </Typography>
              <Grid container spacing={2} mt={0}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="De"
                      value={startDateChecklist}
                      onChange={(newValue: any) =>
                        setStartDateChecklist(newValue)
                      }
                      format="DD/MM/YYYY"
                      sx={{
                        width: "100%",
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#303030",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 3,
                          backgroundColor: "white",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="Até"
                      value={endDateChecklist}
                      onChange={(newValue: any) =>
                        setEndDateChecklist(newValue)
                      }
                      format="DD/MM/YYYY"
                      sx={{
                        width: "100%",
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#303030",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 3,
                          backgroundColor: "white",
                        },
                      }}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>
            </>
          )}
          <Grid container mt={1} spacing={1}>
            <Grid item sm={6} xs={12}>
              <Button
                fullWidth
                onClick={applyFilters}
                disabled={isFetching}
                sx={{
                  backgroundColor: "black",
                  color: "white",
                  marginTop: 2,
                  ":hover": { bgcolor: "#5c5c5c" },
                }}
              >
                {isFetching ? "Aplicando..." : "Aplicar Filtros"}
              </Button>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Button
                fullWidth
                onClick={handleResetFilters}
                sx={{
                  backgroundColor: "red",
                  color: "white",
                  marginTop: 2,
                  ":hover": { bgcolor: "#5c5c5c" },
                }}
              >
                Limpar Filtros
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </React.Fragment>
  );
};

export default FilterVehicle;
